export const RED = { r: 255, g: 0, b: 0, a: 1 };
export const YELLOW = { r: 255, g: 200, b: 0, a: 1 };
export const GREEN = { r: 12, g: 176, b: 57, a: 1 };
export const DEEP_GREEN = { r: 0, g: 103, b: 10, a: 1 };

export const DEFAULT_GOAL_RANGE_SETTING_2 = [
    { value: undefined, color: RED },
    { value: undefined, color: DEEP_GREEN },
];
export const DEFAULT_GOAL_RANGE_SETTING_3 = [
    { value: undefined, color: RED },
    { value: undefined, color: YELLOW },
    { value: undefined, color: DEEP_GREEN },
];
export const DEFAULT_GOAL_RANGE_SETTING_4 = [
    { value: undefined, color: RED },
    { value: undefined, color: YELLOW },
    { value: undefined, color: GREEN },
    { value: undefined, color: DEEP_GREEN },
];
